import {Injectable} from '@angular/core';
import {Observable, Subject, Subscription} from 'rxjs';
import {Message} from '@stomp/stompjs';
import {UpdateVehicleAction} from '../store/vehicle-maintenance/vehicle-maintenance.actions';
import {Store} from '@ngrx/store';
import * as fromRoot from '../store/app.reducers';
import {takeUntil} from 'rxjs/operators';
import {RxStompService} from './rx-stomp.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleWsUpdateService {
  private vehicleUpdate: Observable<Message>;
  private vehicleUpdateSubscription: Subscription;

  constructor(private store: Store<fromRoot.AppState>, private stompService: RxStompService) {
  }

  /**
   * Subscribe to the vehicle update topic to receive updates.
   *
   * @param vehicleId the id of the current vehicle for which updates should be received.
   * @param unsubscribe subject to unsubscribe this registration
   */
  subscribeVehicleUpdateTopic(vehicleId: number, unsubscribe: Subject<void>): void {
    this.vehicleUpdate = this.stompService.watch('/topic/vehicle-update/' + vehicleId);
    this.vehicleUpdateSubscription = this.vehicleUpdate.pipe(takeUntil(unsubscribe))
      .subscribe(this.consumeVehicleUpdateMessage);
  }

  /**
   * Consume message from the stompService (via websockets) to get updates on a vehicle.
   *
   * @message: the message received by the backend, containing a VehicleDetailDto
   */
  public consumeVehicleUpdateMessage = (message: Message) => {
    const vehicleDetailDto = JSON.parse(message.body, (key, value) => {
      if (typeof value === 'string') {
        return value.toUpperCase();
      }
      return value;
    });

    // if message is valid, i.e. contains a vehicle id, dispatch action to redux store to update the vehicle
    if (vehicleDetailDto.vehicleId) {
      this.store.dispatch(new UpdateVehicleAction(vehicleDetailDto.vehicleId));
    } else {
      console.error('Received stomp message without vehicleDetailDto id set, disregarding message.');
    }
  };

  /**
   * Unsubscribe from the current vehicle-update topic.
   */
  public unsubscribeVehicleUpdateTopic(): void {
    if (this.vehicleUpdateSubscription) {
      this.vehicleUpdateSubscription.unsubscribe();
    }
  }
}
